var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { apiEndpoints, CommonConstant, platformIconPath, platformIconPathById, KpiStatus, listOrderedPlatforms } from '../../app.constants';
import { ContactPermissionStatus, GaugeCircleChartData, InfluencerDetail, InfluencerPost, TopExposure, ContentPieChart, PieChartValue, ProgressBar } from '../../../models/influencer';
import { Kpi, KpiItem } from '../../../models/common';
import { BackendHttpService } from '../../core/backend-http.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../common/common.service';
import { Router } from '@angular/router';
import { DemographicHypeAuditor } from '../../../models/demographic/demographic-hype-auditor';
import { ObjectUtils } from '../../utils/object.utils';
import { InfluencerStatus } from '../../../models/influencer/new-influencer';
import { InfluencerIgNewStory } from '../../../models/influencer-ig-new-story';
import { CacheService } from '../cache/cache.service';
import { UserService } from '../user.service';
import { InfluencerPreloadData } from '../../../models/influencer-preload-data';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { StringUtils } from '../../utils/string.utils';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { DateUtils } from '../../utils/date.utils';
import { PendingInfluencerCountryPriority } from '../../../models/influencer/pending-influencer';
import { map } from 'rxjs/operators';
import { PostType } from '../../../models/post-overview';
var InfluencerService = /** @class */ (function (_super) {
    __extends(InfluencerService, _super);
    function InfluencerService(router, translate, userService, cacheService, commonService) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.userService = userService;
        _this.cacheService = cacheService;
        _this.commonService = commonService;
        _this.preloadingSubscriptions = [];
        _this._cachedInfluencerUpdatedSubject = new Subject();
        _this._activeChannelSubject = new BehaviorSubject(null);
        _this.isConfirmNameAndEmailSubject = new BehaviorSubject(false);
        _this.creditAvailability = new BehaviorSubject(null);
        _this._activePendingInfluencer = new BehaviorSubject(null);
        _this.listPendingInfluencer = [];
        _this.loadingNewStoriesEvent = new EventEmitter();
        return _this;
    }
    Object.defineProperty(InfluencerService.prototype, "invalidNewInfluencer", {
        get: function () {
            return this.invalidNewInfluencerData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerService.prototype, "activeChannel", {
        get: function () {
            return this._activeChannelSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerService.prototype, "currentActiveChannel", {
        get: function () {
            return this._activeChannelSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    InfluencerService.prototype.updateActiveChannel = function (channel) {
        this._activeChannelSubject.next(channel);
    };
    InfluencerService.prototype.clearInvalidInfluencerData = function () {
        this.invalidNewInfluencerData = null;
    };
    Object.defineProperty(InfluencerService.prototype, "influencerDetails", {
        get: function () {
            return this.influencerData;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerService.prototype.setInfluencerDetails = function (influencer) {
        this.influencerData = influencer;
    };
    InfluencerService.prototype.clearCachedInfluencerData = function () {
        this.influencerData = null;
    };
    InfluencerService.prototype.getInfluencerPosts = function (influencerId, params) {
        var _this = this;
        return this.get(apiEndpoints.getInfluencerPosts.replace(':influencerId', influencerId), params).map(function (res) {
            if (!res || !res.data) {
                return [];
            }
            var normalizedPostData = res.data.map(function (post) { return Object.assign({}, post, {
                story: post.isStory,
                video: post.isVideo,
                completed: post.isStory && post.isVideo ? post.completed : true
            }); });
            return _this.transformDiscoverPostDataIntoInfluencerPost(normalizedPostData);
        });
    };
    InfluencerService.prototype.transformDiscoverPostDataIntoInfluencerPost = function (dPosts, isFakeStory) {
        var _this = this;
        return dPosts.map(function (item) {
            var post = new InfluencerPost();
            post.blog_id = item.influencerId;
            post.influencerName = item.influencerName;
            post.date = item.publishedDate;
            post.imageUrl = isFakeStory ? 'http://static.getachoo.com/example-story-example.jpg' : item.imageUrl;
            post.videoUrl = item.videoUrl;
            post.influencerName = item.influencerName;
            post.mentions = isFakeStory ? [] : item.mentions;
            post.relativepath = item.relativePath;
            post.url = isFakeStory ? 'https://static.getachoo.com/example-story.mp4' : item.fullUrl;
            post.title = isFakeStory ? null : item.title;
            post.urlHash = item.urlHash;
            post.platformId = item.platform ? item.platform.id : null;
            post.platform = item.platform;
            post.reach = item.reach;
            post.impact = item.impact * 100;
            post.engagement = item.engagement;
            post.isStory = item.story;
            post.completed = item.completed;
            post.isVideo = _this.isVideoPost(item);
            post.mediaWidth = item.mediaWidth;
            post.mediaHeight = item.mediaHeight;
            post.channelId = item.channelId;
            post.postType = item.postType;
            post.interaction = item.interaction;
            return post;
        });
    };
    /**
     * Checking if a post should be shown as video like Instagram Story/Reel or Tiktok
     * @param {DiscoverPost} post
     * @returns {DiscoverPost | any | boolean}
     */
    InfluencerService.prototype.isVideoPost = function (post) {
        return post && post.platform
            && (this.isInstagramStoryVideo(post)
                || this.isInstagramReelVideo(post)
                || (post.platform.id === platformIconPath.tiktok.id));
    };
    InfluencerService.prototype.isInstagramStoryVideo = function (post) {
        return post && post.platform && post.platform.id === platformIconPath.instagram.id && post.story && post.video;
    };
    InfluencerService.prototype.isInstagramReelVideo = function (post) {
        return post && post.platform && post.platform.id === platformIconPath.instagram.id
            && post.postType === PostType.REEL
            && post.video
            && !StringUtils.isUndefinedNullOrEmpty(post.videoUrl);
    };
    InfluencerService.prototype.getPlatformIconById = function (id) {
        return platformIconPathById[id] !== undefined ? platformIconPathById[id].path : '';
    };
    InfluencerService.prototype.getPlatformNameById = function (id) {
        return platformIconPathById[id] !== undefined ? platformIconPathById[id].name : '';
    };
    InfluencerService.prototype.getInstagramAudienceData = function (influencerId) {
        var apiUrl = apiEndpoints.getInstagramAudienceData + "/" + influencerId;
        return this.get(apiUrl);
    };
    InfluencerService.prototype.checkViewDemographicPermission = function (companyId, channelId) {
        // do not need to perform validation for Admin
        if (this.userService.isAdmin) {
            return Observable.of(true);
        }
        return this.get(apiEndpoints.checkDemographic.replace(':companyId', companyId).replace(':channelId', channelId));
    };
    InfluencerService.prototype.getInfluencer = function (influencerId, companyId) {
        var _this = this;
        var influencer;
        // find influencer from preloading data
        if (this.preloadInfluencerData) {
            influencer = this.preloadInfluencerData.influencerList.find(function (infl) { return infl.influencerId === Number(influencerId); });
        }
        if (influencer && !influencer.isOutdated) {
            return Observable.of(this.normalizeInfluencerData(influencer));
        }
        else {
            var apiUrl = apiEndpoints.getInfluencerById + "/" + influencerId;
            if (companyId) {
                apiUrl = apiUrl + ("?companyId=" + companyId);
            }
            return this.get(apiUrl)
                .map(function (res) { return _this.normalizeInfluencerData(res.data); })
                .catch(function (err) { return Observable.of(null); });
        }
    };
    InfluencerService.prototype.normalizeInfluencerData = function (result) {
        var _this = this;
        if (result) {
            var influencer_1 = new InfluencerDetail();
            influencer_1.id = result.influencerId;
            influencer_1.profilePicture = result.profilePicture;
            influencer_1.name = result.influencerName;
            influencer_1.domain = result.domain;
            influencer_1.country = result.country;
            influencer_1.description = result.description;
            influencer_1.platforms = result.platforms;
            influencer_1.numberOfPosts = result.numberOfPosts;
            influencer_1.platformReaches = result.platformReaches;
            influencer_1.topTopics = result.topTopics;
            influencer_1.topMentions = result.topMentions;
            influencer_1.average = result.averageKpis;
            influencer_1.channelAverageKpis = result.channelAverageKpis;
            influencer_1.creditAvailability = result.creditAvailability;
            influencer_1.rawChannelGlobalKpis = result.channelGlobalKpis;
            influencer_1.relatedInfluencers = result.relatedInfluencers;
            influencer_1.brandMentions = result.brandMentions;
            influencer_1.sponsoredOrganicPercentage = result.sponsoredOrganicPercentage;
            if (result.channels) {
                influencer_1.channels = result.channels.map(function (channel) {
                    return Object.assign({}, channel, {
                        platformName: channel.platform.name
                    });
                });
            }
            if (result.channelGlobalKpis && result.channelGlobalKpis.length > 0) {
                influencer_1.channelGlobalKpis = result.channelGlobalKpis.map(function (channelKpi) { return _this.normalizeChannelKpi(channelKpi); });
            }
            if (result.globalKpi) {
                influencer_1.globalKpi = this.normalizeChannelKpi(result.globalKpi);
            }
            this.getChannelAudienceKPIs(result.influencerId).subscribe(function (influencerFollowers) {
                var followers = 0;
                influencerFollowers.forEach(function (follower) {
                    followers += follower.value;
                });
                influencer_1.numberOfFollowers = followers;
            });
            this.influencerData = influencer_1;
            return influencer_1;
        }
    };
    InfluencerService.prototype.normalizeChannelKpi = function (channelKpi) {
        var formattedKpi = new Kpi();
        formattedKpi.engagement = new KpiItem();
        formattedKpi.engagement.value = channelKpi.engagement;
        formattedKpi.engagement.name = 'engagement';
        formattedKpi.engagement.percent = Math.abs(channelKpi.engagement_change) * 100;
        formattedKpi.engagement.status = (channelKpi.engagement_change >= 0) ? 'asc' : 'desc';
        formattedKpi.impact = new KpiItem();
        formattedKpi.impact.value = channelKpi.impact * 100;
        formattedKpi.impact.name = 'impact';
        formattedKpi.impact.percent = Math.abs(channelKpi.impact_change) * 100;
        formattedKpi.impact.status = (channelKpi.impact_change >= 0) ? 'asc' : 'desc';
        formattedKpi.impressions = new KpiItem();
        formattedKpi.impressions.value = channelKpi.impression;
        formattedKpi.impressions.name = 'impressions';
        formattedKpi.impressions.percent = Math.abs(channelKpi.impression_change) * 100;
        formattedKpi.impressions.status = (channelKpi.impression_change >= 0) ? 'asc' : 'desc';
        formattedKpi.reach = new KpiItem();
        formattedKpi.reach.value = channelKpi.reach;
        formattedKpi.reach.name = 'reach';
        formattedKpi.reach.percent = Math.abs(channelKpi.reach_change) * 100;
        formattedKpi.reach.status = (channelKpi.reach_change >= 0) ? 'asc' : 'desc';
        if (channelKpi.channel_id) {
            formattedKpi.channelId = Number(channelKpi.channel_id);
        }
        else {
            formattedKpi.channelId = null;
        }
        return formattedKpi;
    };
    InfluencerService.prototype.getChannelAudienceKPIs = function (influencerId) {
        var apiUrl = apiEndpoints.getChannelAudienceKPIs + "/" + influencerId;
        return this.get(apiUrl).map(function (res) {
            return res && res.data ? res.data.channelAudienceKPIs : [];
        });
    };
    /**
     * This method is used to load data of PlatformReach
     * @param {MeasureSearchCriteria} measure
     * @returns {Observable<PlatformReach[]>}
     */
    InfluencerService.prototype.getPlatformReach = function (measure) {
        var _this = this;
        return this.get(apiEndpoints.getExposurePlatforms, measure).map(function (res) {
            return res.platforms.map(function (platform) { return Object.assign({}, platform, {
                description: _this.translate.instant('INFLUENCER.insight.platform_reach.impact', {
                    impact: Number(platform.progressBar.value).toFixed(1)
                })
            }); });
        });
    };
    /**
     * this method is used to load TopExposure data of influencer or project
     * @param params
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.getExposures = function (params) {
        return this.get(apiEndpoints.getExposures, params);
    };
    InfluencerService.prototype.getTopExposures = function (influencerId, params) {
        var _this = this;
        return this.get(apiEndpoints.getTopExposures.replace(':influencerId', influencerId), params)
            .map(function (res) { return res && res.data ? _this.normalizeTopExposureData(res.data) : null; });
    };
    InfluencerService.prototype.normalizeTopExposureData = function (topExposure) {
        var reach = topExposure.reach || {};
        var engagement = topExposure.engagement || {};
        var impact = topExposure.impact || {};
        var data = {
            reach: new TopExposure(reach.influencerName, reach.influencerId, reach.relativePath, reach.fullUrl, reach.urlHash, reach.publishedDate, reach.imageUrl, reach.title, reach.reach, reach.platform),
            engagement: new TopExposure(engagement.influencerName, engagement.influencerId, engagement.relativePath, engagement.fullUrl, engagement.urlHash, engagement.publishedDate, engagement.imageUrl, engagement.title, engagement.engagement, engagement.platform),
            impact: new TopExposure(impact.influencerName, impact.influencerId, impact.relativePath, impact.fullUrl, impact.urlHash, impact.publishedDate, impact.imageUrl, impact.title, impact.impact * 100, impact.platform),
        };
        return data;
    };
    /**
     * this method is used to load BestPerformingExposure data of influencer or project
     * @param params
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.getBestPerforming = function (influencerId, params) {
        var _this = this;
        return this.get(apiEndpoints.getBestPerforming.replace(':influencerId', influencerId), params)
            .map(function (res) { return res && res.data ? _this.normalizeBestPerfomingData(res.data) : null; });
    };
    InfluencerService.prototype.normalizeBestPerfomingData = function (bestPerfomingPost) {
        return bestPerfomingPost.map(function (item) { return ({
            pieCharts: {
                engagement: { value: item.engagement },
                reach: { value: item.reach },
                impact: { value: item.impact * 100 }
            },
            platform: item.platform ? item.platform.id : 0,
            published_date: item.publishedDate,
            text: item.title,
            image: item.imageUrl,
            influencer_id: item.influencerId,
            url: item.fullUrl,
            urlHash: item.urlHash,
            relativepath: item.relativePath,
            impact: item.impact * 100,
            interaction: item.interaction
        }); });
    };
    InfluencerService.prototype.getDailyKpiTimeLineChart = function (influencerId, params) {
        var _this = this;
        return this.get(apiEndpoints.getDailyKpiTimeLineChart.replace(':influencerId', influencerId), params).map(function (res) {
            if (res && res.data) {
                var dailyKpis = _this.filterDailyKpiByChannel(res.data, params.channelId);
                var data = dailyKpis.sort(function (a, b) { return a.date - b.date; }); // For ascending sort date
                return _this.commonService.normalizeDataForActivityLineChart(data);
            }
            else {
                return null;
            }
        }).catch(function (err) { return Observable.of(null); });
    };
    InfluencerService.prototype.filterDailyKpiByChannel = function (dailyKpis, channelId) {
        if (channelId) {
            return dailyKpis.filter(function (d) { return d.channel && d.channel.id === channelId; });
        }
        else {
            return dailyKpis.filter(function (d) { return !d.channel; });
        }
    };
    /**
     * this method use to load KPI data of Influencer
     * @param {number} influencerId
     * @param {number} period
     * @returns {any}
     */
    InfluencerService.prototype.getPerformanceGlobalKPIs = function (params) {
        return this.get(apiEndpoints.getPerformanceGlobalKPIs, params).map(function (res) {
            var kpiData = new Kpi();
            res.data.KPIs.forEach(function (item) {
                switch (item.name.toLowerCase()) {
                    case CommonConstant.IMPRESSIONS_NAME.toLowerCase():
                        kpiData.impressions = item;
                        break;
                    case CommonConstant.REACH_NAME.toLowerCase():
                        kpiData.reach = item;
                        break;
                    case CommonConstant.IMPACT_NAME.toLowerCase():
                        kpiData.impact = item;
                        break;
                    case CommonConstant.ENGAGEMENT_NAME.toLowerCase():
                        kpiData.engagement = item;
                        break;
                    case CommonConstant.MENTIONS_NAME.toLowerCase():
                        kpiData.mention = item;
                        break;
                    default:
                        break;
                }
            });
            return kpiData;
        });
    };
    /**
     * to get Campaign list of an influencer
     * @param params
     * @returns {any}
     */
    InfluencerService.prototype.getCampaignListOfInfluencer = function (params) {
        var _this = this;
        return this.get(apiEndpoints.getAllCampaignsForInfluencer, params).map(function (res) {
            return res.data.map(function (campaign) { return _this.normalizeCampaignData(campaign); });
        });
    };
    InfluencerService.prototype.normalizeCampaignData = function (campaign) {
        return {
            name: campaign.campaign_name,
            id: campaign.campaign_influencer_id,
            campaignId: campaign.campaign_id,
            campaignInfluencerId: campaign.campaign_influencer_id,
            status: campaign.status,
            campaignType: campaign.campaign_status,
            companyId: campaign.campaign_company_id
        };
    };
    InfluencerService.prototype.getCampaignInfluencerData = function (campaignInfluencerId) {
        var campaignPosts;
        if (this.preloadInfluencerData && this.preloadInfluencerData.campaignPostList) {
            campaignPosts = this.preloadInfluencerData.campaignPostList[campaignInfluencerId];
        }
        if (campaignPosts) {
            return Observable.of(campaignPosts);
        }
        else {
            return this.get(apiEndpoints.getCampaignInfluencerData.replace(':campaignInfluencerId', campaignInfluencerId)).map(function (res) { return res.data; });
        }
    };
    /**
     * to get Campaign KPI of an influencer
     * @param params
     * @returns {any}
     */
    InfluencerService.prototype.getCampaignInfluencerKPIs = function (campaignInfluencerId) {
        return this.get(apiEndpoints.getCampaignInfluencerKPIs + campaignInfluencerId)
            .map(function (res) {
            var postKpi = new Kpi();
            postKpi.engagement.value = res.data.engagement;
            postKpi.impact.value = res.data.impact;
            postKpi.impressions.value = res.data.impression;
            postKpi.reach.value = res.data.reach;
            postKpi.post.value = res.data.post;
            return postKpi;
        });
    };
    /**
     * to get Campaign details of an influencer
     * @param campaignInfluencerId
     * @returns {any}
     */
    InfluencerService.prototype.getCampaignInfluencerDetail = function (campaignInfluencerId) {
        var campaignInfluencerDetails;
        if (this.preloadInfluencerData && this.preloadInfluencerData.campaignInfluencerDetails) {
            campaignInfluencerDetails = this.preloadInfluencerData.campaignInfluencerDetails.find(function (camp) { return camp.campaignInfluencerId === Number(campaignInfluencerId); });
        }
        if (campaignInfluencerDetails) {
            return Observable.of(campaignInfluencerDetails);
        }
        else {
            return this.get(apiEndpoints.getCampaignInfluencerDetail + campaignInfluencerId)
                .map(function (res) { return res && res.data ? res.data : null; });
        }
    };
    /**
     * to update campaign status of an influencer
     * @param data
     * @returns {any}
     */
    InfluencerService.prototype.updateInfluencerCampaignStatus = function (data) {
        return this.post(apiEndpoints.updateInfluencerCampaignStatus, data);
    };
    /**
     * Call API to accept the campaign invitation
     * @param {number} campaignInfluencerId
     * @param {string} accessLevel
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.acceptCampaignInvitation = function (campaignId, influencerId, accessLevel) {
        if (accessLevel === void 0) { accessLevel = 'influencer'; }
        return this.post(apiEndpoints.acceptCampaignInvitation, {
            campaignId: campaignId,
            influencerId: influencerId,
            accessLevel: accessLevel
        });
    };
    /**
     * Call API to decline the campaign invitation
     * @param {number} campaignInfluencerId
     * @param {string} accessLevel
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.declineCampaignInvitation = function (campaignId, influencerId, accessLevel) {
        if (accessLevel === void 0) { accessLevel = 'influencer'; }
        return this.post(apiEndpoints.declineCampaignInvitation, {
            campaignId: campaignId,
            influencerId: influencerId,
            accessLevel: accessLevel
        });
    };
    InfluencerService.prototype.executeInfluencEyeRequest = function (influencerChannelId, companyId) {
        return this.get(apiEndpoints.loadDemographic.replace(':channelId', influencerChannelId.toString()), { companyId: companyId });
    };
    InfluencerService.prototype.loadInfluencEyeData = function (influencerChannelId, companyId) {
        var _this = this;
        return this.executeInfluencEyeRequest(influencerChannelId, companyId).map(function (res) { return res && res.data ? _this.mapDemographicData(res.data) : null; });
    };
    InfluencerService.prototype.updateInfluencerDemographic = function (channelId, companyId) {
        var _this = this;
        return this.get(apiEndpoints.updateDemographic.replace(':channelId', channelId.toString()), { companyId: companyId })
            .map(function (res) { return res && res.data ? _this.mapDemographicData(res.data) : null; });
    };
    InfluencerService.prototype.mapDemographicData = function (rawDemographic) {
        var demographic = new DemographicHypeAuditor();
        demographic.username = rawDemographic.handle;
        demographic.genders = ObjectUtils.parseJSON(rawDemographic.demography);
        demographic.countries = ObjectUtils.parseJSON(rawDemographic.followersGeography || '{}').countries;
        demographic.audienceInterest = ObjectUtils.parseJSON(rawDemographic.audienceThematics);
        demographic.audienceType = ObjectUtils.parseJSON(rawDemographic.likersReach);
        demographic.authenticEngagement = ObjectUtils.parseJSON(rawDemographic.followersReach);
        demographic.cities = ObjectUtils.parseJSON(rawDemographic.followersGeography || '{}').cities;
        demographic.languages = ObjectUtils.parseJSON(rawDemographic.followersLanguages);
        demographic.demographyByAge = ObjectUtils.parseJSON(rawDemographic.demographyByAge);
        var daysDiff = DateUtils.computeTimeDiffInHour(new Date(rawDemographic.modifiedAt), new Date()) / 24;
        demographic.isNew = this.isDemographicNew(rawDemographic);
        demographic.isOutdated = daysDiff > InfluencerService.DEMOGRAPHIC_EXPIRED_DAYS
            || (rawDemographic.version && rawDemographic.version < 2);
        return demographic;
    };
    /*
    Detect where demographic is new created from BE
    */
    InfluencerService.prototype.isDemographicNew = function (rawDemographic) {
        var dateNumber = rawDemographic.modifiedAt;
        dateNumber = (dateNumber === null || dateNumber === undefined)
            ? rawDemographic.createdAt
            : dateNumber;
        if (dateNumber === null || dateNumber === undefined) {
            return false;
        }
        var minutesDiff = DateUtils.computeTimeDiffInHour(new Date(dateNumber), new Date()) * 60;
        return minutesDiff < 1;
    };
    InfluencerService.prototype.addInfluencerByHandle = function (newInfluencer, influencerChannels) {
        var data = {
            channels: influencerChannels
        };
        return this.post(apiEndpoints.addInfluencerByHandle, data);
    };
    InfluencerService.prototype.validateInfluencerData = function (newInfluencer, influencerChannels) {
        var _this = this;
        var errors = [];
        var validPlatforms = [
            platformIconPath.instagram.id,
            platformIconPath.blogs.id,
            platformIconPath.youtube.id,
            platformIconPath.tiktok.id
        ];
        var hasMandatoryChannel = influencerChannels.find(function (ic) { return validPlatforms.indexOf(ic.platform_id) > -1; });
        if (!hasMandatoryChannel) {
            errors.push({
                name: 'newInfluencer.channels',
                message: this.translate.instant('add_influencer_manually.validation.missing_maandatory_channel')
            });
        }
        influencerChannels.forEach(function (channel) {
            var channelPlatform = platformIconPathById[channel.platform_id];
            if (channel && (!channel.handle || channel.handle === '')) {
                errors.push({
                    name: channelPlatform.name.toLowerCase() + '.handle',
                    message: _this.translate.instant('add_influencer_manually.validation.missing_handle', {
                        platform: channelPlatform.name
                    })
                });
            }
        });
        return errors;
    };
    InfluencerService.prototype.validateInfluencerConfirmationData = function (influencer, acceptedTermAndService) {
        var errors = [];
        if (!influencer.fullName || StringUtils.trim(influencer.fullName) === '') {
            errors.push({
                name: 'influencer.fullName',
                message: this.translate.instant('INFLUENCER.confirmation.missing_full_name')
            });
        }
        if (!influencer.email || StringUtils.trim(influencer.email) === '') {
            errors.push({
                name: 'influencer.email',
                message: this.translate.instant('INFLUENCER.confirmation.missing_email')
            });
        }
        else if (influencer.email.indexOf('@') <= 0) {
            errors.push({
                name: 'influencer.email',
                message: this.translate.instant('INFLUENCER.confirmation.wrong_email')
            });
        }
        if (!acceptedTermAndService) {
            errors.push({
                name: 'influencer.acceptedTermAndService',
                message: this.translate.instant('INFLUENCER.confirmation.accept_term_service')
            });
        }
        return errors;
    };
    /**
   * add new influencer manually
   * @param {NewInfluencer} newInfluencer
   * @param {NewInfluencerChanel[]} influencerChannels
   * @param afterAddingCallback
   */
    InfluencerService.prototype.addNewInfluencer = function (newInfluencer, influencerChannels, afterAddingCallback, errorCallback) {
        var _this = this;
        // if influencer already existed. Don't create influencer again. Just add channel
        if (newInfluencer.id > 0) {
            this.addChannelToInfluencer(newInfluencer, influencerChannels, afterAddingCallback, errorCallback);
            return;
        }
        // get influencer name. If it's undefined. Use it's IG handle
        var influencerName = newInfluencer.domain;
        if (!influencerName && influencerChannels.length > 0) {
            influencerName = influencerChannels[0].handle;
        }
        var data = {
            country: newInfluencer.country,
            domain: influencerName,
            email: newInfluencer.email,
            gender: newInfluencer.gender,
            isActive: InfluencerStatus.NEW,
            languages: newInfluencer.languages,
            name: influencerName,
            network: '',
            pending_completed: null,
            system_email: newInfluencer.systemEmail
        };
        this.post(apiEndpoints.addInfluencer, data).subscribe(function (res) {
            _this.addChannelToInfluencer(res.data, influencerChannels, afterAddingCallback, errorCallback);
            return res;
        }, function (err) {
            if (errorCallback) {
                errorCallback(err);
                _this.invalidNewInfluencerData = { newInfluencer: newInfluencer, influencerChannels: influencerChannels };
            }
        });
    };
    InfluencerService.prototype.addChannelToInfluencer = function (influencer, influencerChannels, afterAddingCallback, errorCallback) {
        var _this = this;
        // stop adding channel if empty
        if (influencerChannels.length === 0) {
            afterAddingCallback(influencer);
            return;
        }
        var influencerChannelObservers = [];
        influencerChannels.forEach(function (channel) {
            if (channel.handle && channel.handle !== '') {
                influencerChannelObservers.push(_this.addInfluencerChannel(influencer.id, channel));
            }
        });
        Observable.forkJoin(influencerChannelObservers).subscribe(function (r2) {
            // run callback
            if (afterAddingCallback) {
                afterAddingCallback(influencer);
            }
        }, function (err) {
            if (errorCallback) {
                errorCallback(err);
                _this.invalidNewInfluencerData = { newInfluencer: influencer, influencerChannels: influencerChannels };
            }
        });
    };
    InfluencerService.prototype.deleteInfluencerChannel = function (channelId) {
        return this.post(apiEndpoints.deleteChannel, {
            id: channelId
        });
    };
    InfluencerService.prototype.createOrUpdateNote = function (note) {
        return this.post(apiEndpoints.influencerNote.replace(':influencerId', note.influencerId.toString()), note);
    };
    InfluencerService.prototype.loadNoteListOfInfluencer = function (influencerId) {
        return this.get(apiEndpoints.influencerNote.replace(':influencerId', influencerId.toString()));
    };
    InfluencerService.prototype.deleteNote = function (noteId) {
        return this.delete(apiEndpoints.deleteNote.replace(':noteId', noteId.toString()));
    };
    InfluencerService.prototype.addInfluencerChannel = function (influencerId, handle) {
        var data = Object.assign({}, handle, {
            blog_id: influencerId
        });
        return this.post(apiEndpoints.addChannel, data);
    };
    InfluencerService.prototype.addChannelByInfluencer = function (influencerId, handle) {
        var data = Object.assign({}, handle, {
            blog_id: influencerId
        });
        return this.post(apiEndpoints.addChannelByUser, data);
    };
    InfluencerService.prototype.updateInfluencerChannel = function (channelId, channelData) {
        return this.post(apiEndpoints.updateChannel, channelData).map(function (res) { return res ? res.data : null; });
    };
    InfluencerService.prototype.precheckInfluencerChannel = function (channelId, channelData) {
        return this.post(apiEndpoints.precheckChannel, channelData).map(function (res) { return res ? res.data : null; });
    };
    InfluencerService.prototype.getInfluencerLoginStatus = function (channelId) {
        return this.get(apiEndpoints.loginStatus, { channelId: channelId }).map(function (res) { return res ? res.data : null; });
    };
    InfluencerService.prototype.getInfluencerChannels = function (influencerId) {
        return this.get(apiEndpoints.getInfluencerChannels.replace(':influencerId', influencerId)).map(function (res) { return res ? res.data : null; });
    };
    /**
     * using this method to fire event when getting new status from server
     * @param {InfluencerIgStoryLoadingStatus} newStatus
     */
    InfluencerService.prototype.updateNewIgStory = function (igNewStoryLoader) {
        this.influencerIgNewStory = igNewStoryLoader;
        this.loadingNewStoriesEvent.emit(igNewStoryLoader.status);
    };
    InfluencerService.prototype.updateNewIgStoryStatus = function (newStatus) {
        if (!this.influencerIgNewStory) {
            this.influencerIgNewStory = new InfluencerIgNewStory();
        }
        this.influencerIgNewStory.status = newStatus;
        this.loadingNewStoriesEvent.emit(newStatus);
    };
    InfluencerService.prototype.getLatestNewStory = function () {
        return this.influencerIgNewStory;
    };
    InfluencerService.prototype.clearNewIgStory = function () {
        this.influencerIgNewStory = null;
        this.loadingNewStoriesEvent.emit(null);
    };
    InfluencerService.prototype.fetchNewIgStories = function (influencerId, lastSeenTime, loaderIds) {
        var _this = this;
        var storyRequest;
        var params = {};
        if (loaderIds) {
            params = Object.assign({}, params, {
                loaderIds: loaderIds
            });
        }
        if (lastSeenTime) {
            params = Object.assign({}, params, {
                lastSeenTime: lastSeenTime
            });
        }
        storyRequest = this.get(apiEndpoints.influencerNewStories.replace(':influencerId', String(influencerId)), params);
        return storyRequest.map(function (res) {
            if (res && res.data) {
                _this.updateNewIgStory(res.data);
                return res.data;
            }
            else {
                return null;
            }
        });
    };
    InfluencerService.prototype.getNewIgStories = function () {
        return this.influencerIgNewStory ? this.influencerIgNewStory.newIgStories : [];
    };
    /**
     * influencer decline the campaign invitation
     * @param campaignInfluencerId
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.rejectCampaign = function (campaignInfluencerId) {
        return this.post(apiEndpoints.rejectCampaign, {
            campaignInfluencerId: campaignInfluencerId,
            accessLevel: 'influencer'
        });
    };
    /**
     * Preloading data of influencer belonged to a group
     * @param {number[]} influencerIds
     * @param {number[]} campaignInfluencerIds
     * @param {boolean} loadMore
     * @param {number} limit
     * @param {number} page
     * @param {number} pageSize
     */
    InfluencerService.prototype.preloadInfluencerDataByIdList = function (influencerIds, campaignInfluencerIds, loadMore, limit, page, pageSize) {
        var _this = this;
        if (limit === void 0) { limit = 20; }
        if (page === void 0) { page = CommonConstant.START_PAGE_INDEX; }
        if (pageSize === void 0) { pageSize = 50; }
        if (!loadMore) {
            this.cancelCurrentPreloadingRequest();
        }
        var chunkedInfluencerList = this.chunkInfluencerList(influencerIds);
        chunkedInfluencerList.forEach(function (chunk) {
            _this.preloadInfluencerListInternally(chunk, campaignInfluencerIds, limit, page, pageSize);
        });
    };
    /**
     * preloading data of influencer belonged to campagin list
     * @param {any[]} influencer
     * @param {boolean} loadMore
     * @param {number} limit
     * @param {number} page
     * @param {number} pageSize
     */
    InfluencerService.prototype.preloadCampaignInfluencerDataByIdList = function (influencer, loadMore, limit, page, pageSize) {
        var _this = this;
        if (limit === void 0) { limit = 20; }
        if (page === void 0) { page = CommonConstant.START_PAGE_INDEX; }
        if (pageSize === void 0) { pageSize = 50; }
        if (!loadMore) {
            this.cancelCurrentPreloadingRequest();
        }
        var chunkedInfluencerList = this.chunkInfluencerList(influencer);
        chunkedInfluencerList.forEach(function (chunk) {
            var campaignInfluencerIds = chunk.map(function (inf) { return inf.campaign_influencer_id; });
            var influencerList = chunk.map(function (inf) { return inf.influencer_id; });
            _this.preloadInfluencerListInternally(influencerList, campaignInfluencerIds, limit, page, pageSize);
        });
    };
    InfluencerService.prototype.loadListChannelOfInfluencer = function (influencerId) {
        return this.get(apiEndpoints.getInfluencerChannels.replace(':influencerId', influencerId.toString()))
            .map(function (res) { return res && res.data ? res.data : []; });
    };
    InfluencerService.prototype.preloadInfluencerListInternally = function (influencerIds, campaignInfluencerIds, limit, page, pageSize) {
        var _this = this;
        // start fetching new preloading data
        var data = {
            influencers: influencerIds,
            period: CommonConstant.PERIOD_30_DAYS,
            limit: limit
        };
        var requests = [
            this.post(apiEndpoints.loadInfluencerList, data).map(function (res) { return res ? res.data : []; }),
            this.post(apiEndpoints.getCampaignsOfInfluencerList + "?company_id=" + this.userService.getCompanyId(), {
                influencers: influencerIds,
                page: page,
                pageSize: pageSize
            }).map(function (res) { return res ? res.data : []; }),
        ];
        if (Array.isArray(campaignInfluencerIds) && campaignInfluencerIds.length > 0) {
            var campaignRequest = {
                influencers: influencerIds,
                campaignInfluencerIds: campaignInfluencerIds,
                page: page,
                pageSize: pageSize
            };
            requests.push(this.post(apiEndpoints.getCampaignInfluencerDetailList, campaignRequest).map(function (res) { return res ? res.data : []; }));
        }
        var preloadingSubscription = forkJoin.apply(void 0, requests).subscribe(function (res) {
            if (!_this.preloadInfluencerData) {
                _this.preloadInfluencerData = new InfluencerPreloadData();
            }
            (_a = _this.preloadInfluencerData.influencerList).push.apply(_a, res[0]);
            (_b = _this.preloadInfluencerData.campaignInfluencerList).push.apply(_b, res[1]);
            if (res.length <= 2) {
                _this.preloadCampaignInfluencerData(res[1], page, pageSize);
            }
            else {
                (_c = _this.preloadInfluencerData.campaignInfluencerDetails).push.apply(_c, res[2]);
            }
            var _a, _b, _c;
        });
        this.preloadingSubscriptions.push(preloadingSubscription);
    };
    InfluencerService.prototype.preloadCampaignInfluencerData = function (campaignInfluencerList, page, pageSize) {
        var _this = this;
        // don't preload campaign data if influencer doesn't join any campaign yet
        if (!campaignInfluencerList || campaignInfluencerList.length === 0) {
            return;
        }
        var campaignInfluencerIds = campaignInfluencerList.map(function (ci) { return ci.campaign_influencer_id; });
        var campaignRequest = {
            campaignInfluencerIds: campaignInfluencerIds,
            page: page,
            pageSize: pageSize
        };
        var preloadCampSubscription = this.post(apiEndpoints.getCampaignInfluencerDetailList, campaignRequest)
            .map(function (res) { return res ? res.data : []; })
            .subscribe(function (res) {
            if (!_this.preloadInfluencerData) {
                _this.preloadInfluencerData = new InfluencerPreloadData();
            }
            (_a = _this.preloadInfluencerData.campaignInfluencerDetails).push.apply(_a, res);
            var _a;
        });
        this.preloadingSubscriptions.push(preloadCampSubscription);
    };
    InfluencerService.prototype.extractHADemographicReportGeneratingTime = function (message) {
        var numb = message.match(/\d+/g);
        return numb.length > 0 ? numb[0] : null;
    };
    InfluencerService.prototype.cancelCurrentPreloadingRequest = function () {
        this.preloadInfluencerData = null;
        this.preloadingSubscriptions.forEach(function (sub) {
            if (sub) {
                sub.unsubscribe();
            }
        });
    };
    InfluencerService.prototype.updateInfluencerData = function (influencerId, influencerData) {
        return this.post(apiEndpoints.updateInfluencer.replace(':influencerId', influencerId.toString()), influencerData);
    };
    /**
     * Send a request permission for contact from advertiser to influencer
     * @param {number} companyId, {number} influencerId
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.requestPermission = function (companyId, influencerId) {
        return this.post(apiEndpoints.requestPermission.replace(':companyId', companyId)
            .replace(':influencerId', influencerId), {}).map(function (res) { return res ? res.data : null; });
    };
    /**
     * Call to accept contact permission from advertiser
     * @param {string} token
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.acceptContactPermission = function (token) {
        return this.post(apiEndpoints.contactPermission, {
            status: ContactPermissionStatus.ACCEPTED,
            token: token
        }).map(function (res) { return res ? res.data : null; });
    };
    /**
     * Call to reset contact permission from advertiser
     * @param {string} token
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.resetContactPermission = function (token) {
        return this.post(apiEndpoints.contactPermission, {
            status: ContactPermissionStatus.REQUESTED,
            token: token
        }).map(function (res) { return res ? res.data : null; });
    };
    /**
     * Call to reject contact permission from advertiser
     * @param {string} token
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.rejectContactPermission = function (token) {
        return this.post(apiEndpoints.contactPermission, {
            status: ContactPermissionStatus.REJECTED,
            token: token
        }).map(function (res) { return res ? res.data : null; });
    };
    InfluencerService.prototype.chunkInfluencerList = function (influencerList) {
        var chunkedList = [];
        var tempArray = [];
        var i, j;
        var chunkSize = 50;
        for (i = 0, j = influencerList.length; i < j; i += chunkSize) {
            tempArray = influencerList.slice(i, i + chunkSize);
            chunkedList.push(tempArray);
        }
        return chunkedList;
    };
    InfluencerService.prototype.confirmInfluencer = function (influencerId, influencer) {
        return this.post(apiEndpoints.confirmInfluencer.replace(':influencerId', influencerId.toString()), influencer);
    };
    /**
     * Request send a new Campaign Invitation
     * @param {number} influencerId
     * @param {number} campaignId
     * @param {RequestInfluencerType} requestType
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.requestNewCampaignInvitation = function (influencerId, campaignInfluencerId, requestType) {
        return this.post(apiEndpoints.requestNewInvitation.replace(':influencerId', influencerId.toString()), {
            requestType: requestType,
            id: campaignInfluencerId
        });
    };
    /**
     * Request send a new Contact Permission request
     * @param {number} influencerId
     * @param {number} contactPermissionId
     * @param {RequestInfluencerType} requestType
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.requestNewContactPermissionInvitation = function (influencerId, contactPermissionId, requestType) {
        return this.post(apiEndpoints.requestNewInvitation.replace(':influencerId', influencerId.toString()), {
            requestType: requestType,
            id: contactPermissionId
        });
    };
    /**
     * fetch list channel belonged to given influencer
     * @param influencerId
     * @returns {Observable<any>}
     */
    InfluencerService.prototype.fetchListChannel = function (influencerId) {
        return this.cacheService.get("influencer_channels_" + influencerId, this.loadListChannelOfInfluencer(influencerId))
            .map(function (res) { return res.map(function (c) { return ({
            id: c.id,
            handle: c.handle,
            name: c.platform ? "@" + c.handle : null,
            platformId: c.platform ? c.platform.id : null,
            platformName: c.platform ? c.platform.name.toLowerCase() : '',
            isAuthorized: c.type && c.type === 1
        }); }); });
    };
    InfluencerService.prototype.activeInfluencer = function (influencerId) {
        return this.post(apiEndpoints.activeInfluencer.replace(':influencerId', influencerId.toString()), {});
    };
    InfluencerService.prototype.visitInfluencer = function (influencerId, companyId) {
        // not allow to mark influencer as visted for Admin, Influencer and Analyst account.
        if (this.userService.isAdmin || this.userService.isInfluencer || this.userService.isAnalyst) {
            return Observable.of(null);
        }
        var url = apiEndpoints.visitInfluencer.replace(':influencerId', influencerId.toString());
        var fullUrl = url + "?companyId=" + companyId;
        return this.post(fullUrl, {});
    };
    Object.defineProperty(InfluencerService.prototype, "confirmInfluencerNameAndEmailObserver", {
        get: function () {
            return this.isConfirmNameAndEmailSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    InfluencerService.prototype.confirmingInfluencerNameAndEmail = function () {
        this.isConfirmNameAndEmailSubject.next(true);
    };
    InfluencerService.prototype.confirmedInfluencerNameAndEmail = function () {
        this.isConfirmNameAndEmailSubject.next(false);
    };
    InfluencerService.prototype.checkInfluencerCreditAvailability = function (influencerId, companyId) {
        var _this = this;
        var apiUrl = apiEndpoints.getInfluencerById + "/" + influencerId + "?companyId=" + companyId;
        return this.get(apiUrl).subscribe(function (res) {
            if (res && res.data) {
                _this.creditAvailability.next(res.data.creditAvailability);
                _this.updateCachingInfluencerData(influencerId, res.data);
            }
        });
    };
    InfluencerService.prototype.updateCachingInfluencerData = function (influencerId, updatedData) {
        // update preloading data
        var influencerIndex;
        if (this.preloadInfluencerData) {
            influencerIndex = this.preloadInfluencerData.influencerList.findIndex(function (infl) { return infl.influencerId === Number(influencerId); });
        }
        if (influencerIndex >= 0) {
            var preloadedInfluencer = this.preloadInfluencerData.influencerList[influencerIndex];
            preloadedInfluencer.averageKpis = updatedData.averageKpis;
            preloadedInfluencer.channelAverageKpis = updatedData.channelAverageKpis;
            preloadedInfluencer.brandMentions = updatedData.brandMentions;
            preloadedInfluencer.relatedInfluencers = updatedData.relatedInfluencers;
            preloadedInfluencer.sponsoredOrganicPercentage = updatedData.sponsoredOrganicPercentage;
            preloadedInfluencer.channels = updatedData.channels;
            preloadedInfluencer.isOutdated = false;
            this._cachedInfluencerUpdatedSubject.next(updatedData);
            // remove caching data
            this.cacheService.clear("influencer_" + influencerId);
        }
    };
    InfluencerService.prototype.markPreloadedInfluencerOutdated = function (influencerId) {
        // mark preloaded influncer outdated
        var influencerIndex;
        if (this.preloadInfluencerData) {
            influencerIndex = this.preloadInfluencerData.influencerList.findIndex(function (infl) { return infl.influencerId === Number(influencerId); });
        }
        if (influencerIndex >= 0) {
            var preloadedInfluencer = this.preloadInfluencerData.influencerList[influencerIndex];
            preloadedInfluencer.isOutdated = true;
        }
        // clear cache
        var cacheKey = "influencer_" + influencerId;
        if (this.cacheService.has(cacheKey)) {
            this.cacheService.clear(cacheKey);
        }
    };
    InfluencerService.prototype.isCreditAvailable = function () {
        return this.creditAvailability.getValue();
    };
    Object.defineProperty(InfluencerService.prototype, "creditAvailabilityObserve", {
        get: function () {
            return this.creditAvailability.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerService.prototype, "cachedInfluencerUpdated", {
        get: function () {
            return this._cachedInfluencerUpdatedSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    InfluencerService.prototype.normalizeChannelAverageKpi = function (channelAverageKpis, averageKpis, activeChannel) {
        if (!Array.isArray(channelAverageKpis) || channelAverageKpis.length === 0) {
            return null;
        }
        var average;
        if (activeChannel) {
            average = channelAverageKpis.find(function (ak) { return Number(ak.channel_id) === activeChannel.id; });
        }
        else {
            average = averageKpis;
        }
        if (!average || (!average.reach_avg && !average.impression_avg && !average.engagement_avg)) {
            return null;
        }
        var averageKpi = new Kpi();
        averageKpi.isAverage = true;
        averageKpi.reach.value = average.reach_avg || 0;
        averageKpi.reach.name = this.translate.instant('INFLUENCER.insight.kpi.reach');
        averageKpi.impressions.value = average.impression_avg || 0;
        averageKpi.impressions.name = this.translate.instant('INFLUENCER.insight.kpi.impressions');
        averageKpi.engagement.value = average.engagement_avg || 0;
        averageKpi.engagement.name = this.translate.instant('INFLUENCER.insight.kpi.engagement');
        averageKpi.impact.value = average.impact_avg ? average.impact_avg * 100 : 0;
        // engagement rate
        averageKpi.engagementRate.name = this.translate.instant('INFLUENCER.insight.kpi.engagement_rate');
        averageKpi.engagementRate.value = average.engagement_rate_avg ? average.engagement_rate_avg * 100 : 0;
        averageKpi.engagementRate.status = average.engagement_rate_change && average.engagement_rate_change < 0 ? KpiStatus.DESC : KpiStatus.ASC;
        averageKpi.engagementRate.percent = typeof average.engagement_rate_change === 'number' ? Math.abs(Math.round(average.engagement_rate_change * 100)) : null;
        averageKpi.channelId = Number(average.channel_id);
        if (activeChannel) {
            averageKpi.platformName = activeChannel.platformName;
        }
        return averageKpi;
    };
    InfluencerService.prototype.calculatePlatformReach = function (platformReachesArr) {
        var _this = this;
        var activePlatformReaches = [];
        var selectedPlatformReaches = [];
        var platformReachs = [];
        platformReachesArr.forEach(function (plr) {
            var item = new GaugeCircleChartData();
            var description = _this.translate.instant('INFLUENCER.insight.platform_reach.impact', {
                impact: Number(plr.impact * 100).toFixed(1)
            });
            var name = _this.getPlatformNameById(plr.platform);
            item = _this.calculateGaugeCircleChartData(plr.reachChange, plr.reach, name, plr.reachChange, plr.reachPercent, null, description, 'reach');
            platformReachs.push(item);
            var platform = listOrderedPlatforms.find(function (p) { return p.id === plr.platform; });
            activePlatformReaches.push(platform);
            selectedPlatformReaches.push(plr.platform);
        });
        return {
            platformReachs: platformReachs,
            activePlatformReaches: activePlatformReaches,
            selectedPlatformReaches: selectedPlatformReaches
        };
    };
    InfluencerService.prototype.getChannelFollowerData = function (influencerId, channelIds) {
        var apiUrl = apiEndpoints.channelFollowers.replace(':influencerId', influencerId);
        var channelIdsString = null;
        if (channelIds) {
            channelIdsString = channelIds.toString();
        }
        apiUrl = channelIdsString ? apiUrl + ("?channelIds=" + channelIdsString) : apiUrl;
        return this.get(apiUrl).map(function (res) { return res && res.data ? res.data : null; });
    };
    InfluencerService.prototype.calculateChannelFollower = function (channelFollowersData) {
        var _this = this;
        var calculatedChannelFollower = [];
        var selectedChannelFollower = [];
        if (channelFollowersData.channels.length > 0) {
            channelFollowersData.channels = channelFollowersData.channels.sort(function (a, b) { return b.followerCount - a.followerCount; }).slice(0, 4);
            channelFollowersData.channels.forEach(function (cl) {
                var item = new GaugeCircleChartData();
                var progressValue = cl.followerCount / channelFollowersData.influencer.followerCount;
                item = _this.calculateGaugeCircleChartData(cl.followerCountChange, cl.followerCount, cl.handle, cl.followerCountChange, progressValue, cl.platformId);
                item.contentPieChart.reach.tooltipInfo = cl.lastUpdated ? _this.translate.instant('INFLUENCER.last_updated_follower', {
                    last_updated: DateUtils.convertDateToString(cl.lastUpdated, 'dd MMM yyyy')
                }) : null;
                calculatedChannelFollower.push(item);
                selectedChannelFollower.push(cl.channelId);
            });
        }
        return {
            calculatedChannelFollower: calculatedChannelFollower,
            selectedChannelFollower: selectedChannelFollower
        };
    };
    InfluencerService.prototype.calculateGaugeCircleChartData = function (percent, value, name, valueChange, progressValue, platformId, description, contentPieChartName) {
        var item = new GaugeCircleChartData();
        item.contentPieChart = new ContentPieChart();
        item.contentPieChart.reach = new PieChartValue();
        item.contentPieChart.reach.percent = Math.abs(percent) * 100;
        item.contentPieChart.reach.value = value;
        item.contentPieChart.reach.status = (valueChange >= 0) ? KpiStatus.ASC : KpiStatus.DESC;
        item.progressBar = new ProgressBar();
        item.progressBar.value = progressValue * 100;
        item.description = description;
        item.name = name;
        if (contentPieChartName) {
            item.contentPieChart.reach.name = contentPieChartName;
            item.progressBar.name = contentPieChartName;
        }
        if (platformId > 0) {
            item.platformName = listOrderedPlatforms.filter(function (lp) { return lp.id === platformId; })[0].name.toLowerCase();
        }
        return item;
    };
    Object.defineProperty(InfluencerService.prototype, "activePendingInfluencer", {
        get: function () {
            return this._activePendingInfluencer.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    InfluencerService.prototype.loadPendingInfluencerList = function (complete, error) {
        var _this = this;
        this.get(apiEndpoints.getPendingInfluencers, {
            count: 5
        }).subscribe(function (res) {
            if (res && res.data) {
                _this.handlePendingInfluencerList(res.data);
                complete();
            }
        }, function (err) {
            error(err);
        });
    };
    InfluencerService.prototype.handlePendingInfluencerList = function (data) {
        var _this = this;
        this.totalPendingInfluencer = data.number_pending_influencer;
        this.numberOfPendingInfluencersInCampaign = data.number_pending_influencer_in_campaign;
        var pendingInfluencers = data.pending_influencers.map(function (pi) { return Object.assign({}, pi, __assign({ languages: pi.languages && pi.languages.length > 0 ? pi.languages[0] : null }, _this.getPendingInfluencerCountryPriorityInfo(pi))); });
        if (pendingInfluencers.length > 0) {
            (_a = this.listPendingInfluencer).push.apply(_a, pendingInfluencers);
            this._activePendingInfluencer.next(pendingInfluencers[0]);
        }
        var _a;
    };
    InfluencerService.prototype.getPendingInfluencerCountryPriorityInfo = function (pi) {
        var countryPriority = null;
        var countryPriorityUserName = null;
        if (pi.country_priority) {
            var priority = pi.country_priority;
            switch (priority.priority) {
                case 1:
                    {
                        if (priority.user) {
                            var userRoleId = priority.user.role_id;
                            switch (userRoleId) {
                                case 1:
                                    countryPriority = PendingInfluencerCountryPriority.SET_BY_ADMIN;
                                    break;
                                case 2:
                                    countryPriority = PendingInfluencerCountryPriority.SET_BY_USER;
                                    break;
                                case 3:
                                    countryPriority = PendingInfluencerCountryPriority.SET_BY_ANALYST;
                                    break;
                                default:
                                    countryPriority = PendingInfluencerCountryPriority.SET_MANUALLY;
                                    break;
                            }
                            countryPriorityUserName = priority.user.user_full_name;
                        }
                        else {
                            countryPriority = PendingInfluencerCountryPriority.SET_MANUALLY;
                        }
                    }
                    break;
                case 2:
                    countryPriority = PendingInfluencerCountryPriority.DISCOVERED_VIA_FLAG;
                    break;
                case 3:
                    countryPriority = PendingInfluencerCountryPriority.DISCOVERED_VIA_POST_GEO_TAGS;
                    break;
                case 4:
                    countryPriority = PendingInfluencerCountryPriority.DISCOVERED_VIA_POST_PHONE_NO;
                    break;
                default:
                    countryPriority = null;
                    break;
            }
        }
        return { countryPriority: countryPriority, countryPriorityUserName: countryPriorityUserName };
    };
    InfluencerService.prototype.getNextPendingInfluencer = function (complete, error) {
        var currentPendingInfluencer = this._activePendingInfluencer.getValue();
        if (!currentPendingInfluencer) {
            complete();
            return;
        }
        var currentPendingInfluencerIdx = this.listPendingInfluencer.findIndex(function (pi) { return pi.id === currentPendingInfluencer.id; });
        if (currentPendingInfluencerIdx < 0) {
            error();
        }
        else if (currentPendingInfluencerIdx < this.listPendingInfluencer.length - 1) {
            this._activePendingInfluencer.next(this.listPendingInfluencer[currentPendingInfluencerIdx + 1]);
            complete();
        }
        else {
            this.loadPendingInfluencerList(complete, error);
        }
    };
    InfluencerService.prototype.updatePendingInfluencerError = function (processingInfluencer) {
        this._activePendingInfluencer.next(processingInfluencer);
    };
    InfluencerService.prototype.getPreviousPendingInfluencer = function (complete, error) {
        var _this = this;
        var currentPendingInfluencer = this._activePendingInfluencer.getValue();
        if (!currentPendingInfluencer) {
            complete();
            return;
        }
        var currentPendingInfluencerIdx = this.listPendingInfluencer.findIndex(function (pi) { return pi.id === currentPendingInfluencer.id; });
        if (currentPendingInfluencerIdx <= 0) {
            error();
        }
        else {
            var previousInfluencer = this.listPendingInfluencer[currentPendingInfluencerIdx - 1];
            this.get(apiEndpoints.getPendingInfluencerById.replace(':influencer_id', previousInfluencer.id.toString())).subscribe(function (res) {
                if (res && res.data) {
                    var pendingInfluencer = res.data.pending_influencer;
                    var normalizedPendingInfluencer = Object.assign({}, pendingInfluencer, {
                        languages: pendingInfluencer.languages && pendingInfluencer.languages.length > 0 ? pendingInfluencer.languages[0] : null
                    });
                    _this._activePendingInfluencer.next(normalizedPendingInfluencer);
                    _this.updatePendingInfluencerList(normalizedPendingInfluencer);
                }
                complete();
            }, function (err) {
                error();
            });
        }
    };
    InfluencerService.prototype.isLastPendingInfluencer = function (pendingInfluencer) {
        return this.listPendingInfluencer.length > 0 && this.listPendingInfluencer[this.listPendingInfluencer.length - 1].id === pendingInfluencer.id;
    };
    InfluencerService.prototype.updatePendingInfluencer = function (pendingInfluencer, newChannelIds, updatedChannelIds) {
        var _this = this;
        var data = Object.assign({}, pendingInfluencer, {
            new_channels: newChannelIds,
            updated_channels: updatedChannelIds,
            languages: [pendingInfluencer.languages]
        });
        delete data.channels;
        return this.put(apiEndpoints.getPendingInfluencerById.replace(':influencer_id', pendingInfluencer.id.toString()), data).map(function (res) {
            _this.totalPendingInfluencer = res.data.number_pending_influencer;
            _this.numberOfPendingInfluencersInCampaign = res.data.number_pending_influencer_in_campaign;
            return res;
        });
    };
    InfluencerService.prototype.getTotalPendingInfluencer = function () {
        return this.totalPendingInfluencer;
    };
    InfluencerService.prototype.getNumberOfPendingInfluencersInCampaign = function () {
        return this.numberOfPendingInfluencersInCampaign;
    };
    InfluencerService.prototype.updatePendingInfluencerList = function (pendingInfluencer) {
        var updatedIndex = this.listPendingInfluencer.findIndex(function (pi) { return pi.id === pendingInfluencer.id; });
        this.listPendingInfluencer.splice(updatedIndex, 1, pendingInfluencer);
    };
    /**
     * get influencer folllower growth
     * @param {number} influencerId
     * @param {number} channelId
     */
    InfluencerService.prototype.getFollowerGrowth = function (channelId) {
        var url = apiEndpoints.getFollowerGrowth.replace(':channelId', channelId.toString());
        return this.get(url).pipe(map(function (res) {
            return res && res.data && res.data.followerGrowth;
        }));
    };
    /**
     * get influencer folllowers
     * @param {number} influencerId
     */
    InfluencerService.prototype.getInfluencerFollowers = function (influencerId) {
        var url = apiEndpoints.getInfluencerFollowers.replace(':influencerId', influencerId.toString());
        return this.get(url).pipe(map(function (res) {
            return res && res.data;
        }));
    };
    /**
     * get Channel Interaction Rate Development
     * @param {number} channelId
     */
    InfluencerService.prototype.getChannelInteractionRateDevelopment = function (channelId) {
        var url = apiEndpoints.getChannelInteractionRateDevelopment.replace(':channelId', channelId.toString());
        return this.get(url).pipe(map(function (res) {
            return res && res.data && res.data.engagementRateGrowth;
        }));
    };
    InfluencerService.DEMOGRAPHIC_EXPIRED_DAYS = 30;
    return InfluencerService;
}(BackendHttpService));
export { InfluencerService };



// WEBPACK FOOTER //
// ./src/app/services/influencer/influencer.service.ts.pre-build-optimizer.js